import {InHouseTaskNames} from '../../constants/InHouseTaskNames';
import ShareOnMessenger from '@/components/Earn/Dialogs/Share-On-Messenger.vue';
import VerifyPhoneDialogs from '@/components/Earn/Dialogs/Daily-Checkin-Dialog.vue';
import InviteFriendsDialog from '@/components/Earn/Dialogs/Invite-Friends-Dialog.vue';
import SubmitReferralDialog from '@/components/Earn/Dialogs/Submit-Referral-Dialog.vue';
import ShareOnTwitterDialog from '@/components/Earn/Dialogs/Share-On-Twitter-Dialog.vue';
import DailyCheckinDialog from '@/components/PhoneVerification/Verify-Phone-Dialogs.vue';
import ShareOnFacebookDialog from '@/components/Earn/Dialogs/Share-On-Facebook-Dialog.vue';
import ShareOnWhatsappDialog from '@/components/Earn/Dialogs/Share-On-Whatsapp-Dialog.vue';
import FollowOnTwitterDialog from '@/components/Earn/Dialogs/Follow-On-Twitter-Dialog.vue';
import FollowUsOnTikTokDialog from '@/components/Earn/Dialogs/Follow-Us-On-TikTok-Dialog.vue';
import LikeUsOnFacebookDialog from '@/components/Earn/Dialogs/Like-Us-On-Facebook-Dialog.vue';
import FollowOnInstagramDialog from '@/components/Earn/Dialogs/Follow-On-Instagram-Dialog.vue';
import CustomerFeedbackDialog from "@/components/Earn/Dialogs/CustomerFeedbackDialog.vue";

export default class DialogFactory {
    static getDialog(type: InHouseTaskNames) {
        switch (type) {
            case InHouseTaskNames.VERIFY_PHONE:
                return DailyCheckinDialog;
            case InHouseTaskNames.SHARE_TWITTER:
                return ShareOnTwitterDialog;
            case InHouseTaskNames.DAILY_CHECK_IN:
                return VerifyPhoneDialogs;
            case InHouseTaskNames.SHARE_FACEBOOK:
                return ShareOnFacebookDialog;
            case InHouseTaskNames.SHARE_WHATSAPP:
                return ShareOnWhatsappDialog;
            case InHouseTaskNames.ENTER_REFERRAL:
                return SubmitReferralDialog;
            case InHouseTaskNames.INVITE_FRIENDS:
                return InviteFriendsDialog;
            case InHouseTaskNames.SHARE_MESSENGER:
                return ShareOnMessenger;
            case InHouseTaskNames.LIKE_US_FACEBOOK:
                return LikeUsOnFacebookDialog;
            case InHouseTaskNames.FOLLOW_US_TIKTOK:
                return FollowUsOnTikTokDialog;
            case InHouseTaskNames.FOLLOW_US_TWITTER:
                return FollowOnTwitterDialog;
            case InHouseTaskNames.CUSTOMER_FEEDBACK:
                return CustomerFeedbackDialog;
            case InHouseTaskNames.FOLLOW_US_INSTAGRAM:
                return FollowOnInstagramDialog;
            default:

        }
    }
}
